'use client';

import { datadogInspector } from '../util/datadogInspector';
import { AsyncLDWrapper } from './AsyncLDWrapper';
import { LDProvider as SDKProvider } from 'launchdarkly-react-client-sdk';

export function LDProvider({
  children,
  options,
  reactOptions,
  awaitLDClient = false,
  ...ldProviderProps
}: Omit<SDKProvider['props'], 'reactOptions'> & {
  reactOptions?: Omit<
    NonNullable<SDKProvider['props']['reactOptions']>,
    'useCamelCaseFlagKeys'
  >;
} & {
  awaitLDClient?: boolean;
}): React.ReactNode {
  return (
    <SDKProvider
      {...ldProviderProps}
      reactOptions={{
        ...reactOptions,
        useCamelCaseFlagKeys: false,
      }}
      options={{
        ...options,
        inspectors: [...(options?.inspectors ?? []), datadogInspector],
      }}
    >
      {awaitLDClient ? <AsyncLDWrapper>{children}</AsyncLDWrapper> : children}
    </SDKProvider>
  );
}
